/** Validate a 13-digit EAN13 by its mod-10 check digit. */
export function isValidEan13(code: string): boolean {
  if (!/^\d{13}$/.test(code)) return false;
  const digits = code.split("").map((d) => Number(d));
  // EAN13 check digit: sum of (d at odd index) * 3 + (d at even index, excl. last) → next multiple of 10.
  let sum = 0;
  for (let i = 0; i < 12; i += 1) {
    const d = digits[i];
    if (d === undefined) return false;
    sum += i % 2 === 0 ? d : d * 3;
  }
  const check = (10 - (sum % 10)) % 10;
  return check === digits[12];
}
